import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class WebVersion extends Service {
  initialVersion?: string;

  @tracked newVersionAvailable = false;

  setCurrentVersion(currentVersion: string) {
    if (currentVersion != null) {
      if (this.initialVersion == null) {
        this.initialVersion = currentVersion;
      } else if (
        this.newVersionAvailable === false &&
        this.initialVersion !== currentVersion
      ) {
        this.newVersionAvailable = true;
      }
    }
  }
}
